import { Component, OnInit } from '@angular/core';
import { ColdwaveMapConstants } from './utils/constant/coldwave-map.constant';
import { isNullOrUndefined } from 'util';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { MapConstants } from 'src/app/utils/map.constant';
import { MapService } from 'src/app/utils/map.service';
import { ColdwaveMapService } from './utils/service/coldwave-map.service';

@Component({
  selector: 'app-coldwave',
  templateUrl: './coldwave.component.html',
  styleUrls: ['./coldwave.component.scss']
})
export class ColdwaveComponent implements OnInit {

   stateName: any;
  layerList: any;
  otherOptions: {};
  initializeBool = true;
  stateId = 'akbm';

  constructor() { 
    this.stateName = ProjConstants.IDTOSTATENAMEMAPPING[this.stateId];
  }

  ngOnInit() {
    this.getLayersList()
    this.getOtherOptions()
  }

  getLayersList() {
    let layerList = [];
    layerList = layerList.concat(this.getCommonLayers());
    this.layerList = layerList;
  }

  getCommonLayers() {
    const layerList: any = ColdwaveMapConstants.CommonLayers;
    for (const i in layerList) {
      if (!isNullOrUndefined(i)) {
        const layer = layerList[i];
        layer['stateName'] = this.stateName;
        if (layer.layerNameType) {
          if (layer['serviceType'] === 'VectorLayer') {
            layer['layerName'] = ProjConstants.STATE_TO_LAYERTYPE_NAME[this.stateName + '_' + layer.layerNameType];
          } else {
            layer['layerName'] = MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + ProjConstants.STATE_TO_LAYERTYPE_NAME[this.stateName + '_' + layer.layerNameType];
          }
        }
        if (layer.serviceType === 'VectorLayer') {
          const today = new Date();
          const startTs = today.getTime()
          const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
          layer['postData'] = {
            component : 'COLDWAVE',
            sUUID : ProjConstants.IDTOUUIDMAPPING[this.stateId],
            pUUID : ProjConstants.IDTOUUIDMAPPING[this.stateId],
            pType : 'COUNTRY',
            cType : 'DISTRICT',
            startTs: startTs,
            endTs: endTs
          };
        }
      }
    }
    return layerList;
  }

  getOtherOptions() {
    const otherOptions = {};
    otherOptions['legend'] = ColdwaveMapConstants.Legend;
    otherOptions['service'] = ColdwaveMapService;
    this.otherOptions = otherOptions;
  }

}

